module.exports = __webpack_public_path__ + "img/G - 05.b4fc5ed7.png";